import {
  Turnstile,
} from "@marsidev/react-turnstile";
import { forwardRef, useImperativeHandle, useRef } from "react";

const SITE_KEY = process.env.REACT_APP_TURNSTILE_SITE_KEY;

const TurnstileWidget = forwardRef(function TurnstileWidget(
  {
    action,
    onTokenChange,
    className = "",
  },
  ref,
) {
  const turnstileRef = useRef(null);

  useImperativeHandle(ref, () => ({
    reset() {
      turnstileRef.current?.reset();
      onTokenChange?.("");
    },

    getResponse() {
      return turnstileRef.current?.getResponse?.() || "";
    },
  }));

  const handleSuccess = (token) => {
    onTokenChange?.(token);
  };

  const handleError = () => {
    onTokenChange?.("");
  };

  const handleExpire = () => {
    onTokenChange?.("");
  };

  if (!SITE_KEY) {
    console.error(
      "Turnstile is not configured: REACT_APP_TURNSTILE_SITE_KEY is missing.",
    );

    return (
      <div
        className={`rounded-md border border-destructive/30 bg-destructive/5 p-3 text-sm text-destructive ${className}`}
      >
        Security verification is currently unavailable. Please try again
        later.
      </div>
    );
  }

  return (
    <div className={className}>
      <Turnstile
        ref={turnstileRef}
        siteKey={SITE_KEY}
        onSuccess={handleSuccess}
        onError={handleError}
        onExpire={handleExpire}
        options={{
          action,
          theme: "auto",
          size: "flexible",
          appearance: "always",
          retry: "auto",
          refreshExpired: "auto",
        }}
      />
    </div>
  );
});

export default TurnstileWidget;